export default __webpack_public_path__ + "static/emka-8e447a97726c6210515f5b8f69f128c5.jpg";